module.exports = __webpack_public_path__ + "img/person-blue.f8a861be.svg";